import { useState } from 'react';

import { ChevronUp, ChevronDown } from '@gympass/yoga-icons';

import * as S from './style';

import { AccordionProps } from '.';

const Accordion: React.FC<AccordionProps> = ({
  titleContent,
  children,
  onClick,
}) => {
  const [collapsable, setCollapsable] = useState(false);

  return (
    <S.AccordionContainer data-testid="accordion">
      <S.TitleContainer>
        {titleContent}
        <S.CollapseAccordion
          data-testid="button"
          onClick={() => {
            setCollapsable(!collapsable);
            onClick?.();
          }}
        >
          {collapsable ? <ChevronUp /> : <ChevronDown />}
        </S.CollapseAccordion>
      </S.TitleContainer>
      <S.Accordion data-testid="content" collapsable={collapsable}>
        {children}
      </S.Accordion>
    </S.AccordionContainer>
  );
};

export default Accordion;
